module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rudy Rucker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Rudy Rucker")]), _vm._v(" is a two-time winner of the Philip K. Dick award and a professor of computer science at San Jose State University. "), _c('I', [_vm._v("White Light")]), _vm._v(", a novel; "), _c('I', [_vm._v("Gnarl!")]), _vm._v(", a collection of his short fiction; and "), _c('I', [_vm._v("Seek!")]), _vm._v(", a collection of essays, are also published by Four Walls Eight Windows.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6qhXx1/images/backcover.jpg?1733067611566",
      "alt": "This image is the cover for the book Master of Space and Time"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Master of Space and Time\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The real world is unbearable to madcap inventor Harry Gerber, so he uses his genius to twist the laws of science and create his own tailor-made universe. "), _c('i', [_vm._v("Master of Space and Time")]), _vm._v(" combines high physics and high jinks, blurring the line between science and magic. From a voyage to a mirror-image world where sluglike parasites make slaves of humanity, to trees and bushes that grow fries and pork chops, to a rain of fish, author Rudy Rucker -- two-time winner of the Philip K. Dick Award -- takes readers on the ultimate joyride. But once the gluons at the core of Harry's creation run out  . . .  disaster looms for Harry and his friends.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thunder’s Mouth Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0